export default "/institutions/banrisul.svg";